import React from "react";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import {Dropdown} from "primereact/dropdown";
import HeaderScreenPresval from "../../../../components/headerScreenPresval";
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";

const ConsultAvailablePTTView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        {props.messagesGrowl}
                        <HeaderScreenPresval headerTitle="Operación \ Valores Disponibles PTM \ Consulta Disponible PTT"
                                             onExpand={props.clearFilters}
                                             actionSearch={props.searchInstitution}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-6 p-col-6">
                                    <SubtitleLabel header="Institución Prestataria" isBold={true}/>
                                    <Dropdown name="institutionObj"
                                              options={props.institutionList}
                                              filterBy="nombreCorto"
                                              optionLabel="nombreCorto"
                                              placeholder="Seleccione..."
                                              onChange={props.onChangeFilter}
                                              value={props.institutionObj}/>
                                </div>
                                <div className="p-col-12 p-md-6 p-col-6">
                                    <br/>
                                    <Button label="Limpiar"
                                            style={{'float': 'right'}}
                                            onClick={props.clearFilters}
                                            className="p-button-secondary"/>
                                </div>
                            </div>
                        </HeaderScreenPresval>
                    </Grid>


                    <Grid item xs={12}>
                        <div style={{textAlign: 'right'}}>
                            <Button label="Contraer / Expandir" className="p-button-secondary"
                                    onClick={props.expandReduceAll}/>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            footerColumnGroup={props.footerColumnGroup}
                            expandedRows={props.expandedRows}
                            onRowToggle={props.handleToggle}
                            value={props.dataConsultAvailable}
                            rowExpansionTemplate={props.rowExpansionTemplate}
                            selectionMode="single"
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column expander={true} style={{width: '3em'}}/>
                            <Column field="emision" header="Emisora" style={{textAlign: 'left'}} sortable={true}/>
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default ConsultAvailablePTTView;